/* eslint-disable */
import { useMemo, useState, useEffect, useRef, React } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import GolferApi from "../../services/golfer-api";
import { Centrifuge } from "centrifuge";
import ViewScoresModal from "../../shared/components/modals/ViewScoresModal";
import JoinChallengeInfoModal from "../../shared/components/modals/JoinChallengeInfoModal";
import JoinedChallengeModal from "../../shared/components/modals/JoinedChallengeModal";
import LeaveChallengeConfirmationModal from "../../shared/components/modals/LeaveChallengeConfirmationModal";
import Navigate from "../../shared/navigation/navigate";
import ChallengeLeaderboardFilter from "./ChallengeLeaderboardFilter";
import { Star, StarOutline } from "@mui/icons-material";
import { store } from "../../shared/store";
import { showToast } from "../../shared/helpers/show-toast";
import ChallengeInfoBox from "./components/ChallengeInfoBox";
import ChallengeActivityBox from "./components/ChallengeActivityBox";
import ChallengeLearnMoreBox from "./components/ChallengeLearnMoreBox";
import { useChallenge } from "./ChallengeContext";

export default function ChallengeOngoing() {
  const {
    challengeInfo,
    selectedStatus,
    isFollowingChecked,
    page,
    setPage,
    pageRef,
    data,
    allScores,
    topScores,
    userProgress,
    setUserProgress,
    progressInfo,
    setProgressInfo,
    totalScore,
    currentUser,
    userName,
    joinedChallenge,
    setJoinedChallenge,
    getData,
    handleStatusChange,
    handleFollowingChange,
    isSmallScreen,
    preview,
  } = useChallenge();

  const [localStorageToken, setLocalStorageToken] = useState(null);
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const [joinedChallengeModalOpen, setJoinedChallengeModalOpen] =
    useState(false);
  const [
    leaveChallengeConfirmationModalOpen,
    setLeaveChallengeConfirmationModalOpen,
  ] = useState(false);
  const [ViewScoresModalOpen, setViewScoresModalOpen] = useState(false);
  const [isError, setIsError] = useState(false);

  const centrifugeRef = useRef(null);
  const subRef = useRef(null);
  const userRowRef = useRef(null);
  const [isRowPinned, setIsRowPinned] = useState(true);
  const tableContainerRef = useRef(null);

  const computed_name =
    currentUser && isSmallScreen
      ? "GOLFER (H.I.)"
      : !currentUser
      ? "GOLFER"
      : "GOLFER (HANDICAP INDEX)";

  const getPrivateToken = async (pageNo) => {
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];
    const response = await GolferApi.getPrivateLeaderboardToken(
      pageNo,
      idFromUrl
    );
    console.log(response.data.token);
    return response.data.token;
  };

  const getToken = async () => {
    const response = await GolferApi.getLeaderboardToken();
    return response.data.token;
  };

  useEffect(() => {
    const token = localStorage.getItem("ghin-user-token");
    setLocalStorageToken(token);
  }, []);

  const ws_connection = (pageNo = 0) => {
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];

    const init = async () => {
      centrifugeRef.current = new Centrifuge(
        process.env.REACT_APP_CENTRIFUGO_URL,
        {
          getToken: getToken,
        }
      );
      centrifugeRef.current.connect();
    };
    init();
    centrifugeRef.current
      .on("connecting", function (ctx) {
        console.log(`connecting: ${ctx.code}, ${ctx.reason}`);
      })
      .on("connected", function (ctx) {
        console.log(`connected over ${ctx.transport}`);
      })
      .on("disconnected", function (ctx) {
        console.log(`disconnected: ${ctx.code}, ${ctx.reason}`);
      })
      .on("unsubscribed", function (ctx) {
        console.log("unsubscribed from server-side channel", ctx.channel);
      })
      .connect();
    if (userName) {
      subRef.current = centrifugeRef.current.newSubscription(
        "$leaderboard:" + idFromUrl + ":private",
        {
          getToken: () => getPrivateToken(pageNo),
        }
      );
      centrifugeRef.current
        .presence("$leaderboard:" + idFromUrl + ":private")
        .then(
          function (resp) {
            console.log(resp);
          },
          function (err) {
            console.log("presence error", err);
          }
        );
    } else {
      subRef.current = centrifugeRef.current.newSubscription(
        "leaderboard:" + idFromUrl + ":public"
      );
      centrifugeRef.current
        .presence("leaderboard:" + idFromUrl + ":public")
        .then(
          function (resp) {
            console.log(resp);
          },
          function (err) {
            console.log("presence error", err);
          }
        );
    }
    subRef.current
      .on("publication", function (ctx) {
        getData(true);
      })
      .on("subscribing", function (ctx) {
        console.log(`subscribing: ${ctx.code}, ${ctx.reason}`);
      })
      .on("subscribed", function (ctx) {
        console.log("subscribed", ctx);
      })
      .on("unsubscribed", function (ctx) {
        console.log(`unsubscribed: ${ctx.code}, ${ctx.reason}`);
      })
      .subscribe();
  };

  const closeModal = () => {
    setInfoModalOpen(false);
  };

  // Functions to open and close the View Scores modal.
  const openViewScoresModal = () => {
    setViewScoresModalOpen(true);
  };

  const closeViewScoresModal = () => {
    setViewScoresModalOpen(false);
  };

  const closeLeaveChallengeConfirmationModal = () => {
    setLeaveChallengeConfirmationModalOpen(false);
  };

  useEffect(() => {
    // ws_connection(0);
    // return () => {
    //   if (centrifuge) {
    //     centrifuge.disconnect();
    //   }
    // };
  }, []);

  useEffect(() => {
    if (!isRowPinned && userRowRef.current && tableContainerRef.current) {
      // Scroll the user row into view (its natural position in the table body)
      userRowRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      // Attach a scroll event listener to re-pin once the user scrolls.
      const container = tableContainerRef.current;
      const handleScroll = () => {
        setIsRowPinned(true);
        container.removeEventListener("scroll", handleScroll);
      };
      container.addEventListener("scroll", handleScroll);

      // Fallback: re-pin after 1 second if no scroll event occurs.
      const timeoutId = setTimeout(() => {
        setIsRowPinned(true);
        container.removeEventListener("scroll", handleScroll);
      }, 1000);

      return () => {
        clearTimeout(timeoutId);
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, [isRowPinned]);

  const handleLoadMore = () => {
    // centrifugeRef.current.removeSubscription(subRef.current);
    // ws_connection(page + 1);
    pageRef.current += 1;
    setPage(page + 1);
  };

  const handleLeaveChallenge = () => {
    const ghinNumber =
      store.getState().authReducer.loginReducer.user.ghin_number;

    GolferApi.leaveChallenge(ghinNumber, challengeInfo?.id)
      .then(() => {
        Navigate.toPath("/profile");
      })
      .catch((error) => {
        console.error("Error during challenge leaving", error);
      });
  };

  const handlePinnedRowClick = () => {
    setIsRowPinned(false);
  };

  const onConfirmChallengeModal = () => {
    const ghin_number =
      store.getState().authReducer.loginReducer.user.ghin_number;
    const path = window.location.pathname;
    const pathParts = path.split("/");
    const idFromUrl = pathParts[pathParts.length - 1];
    let id = idFromUrl;
    GolferApi.joinChallenge(ghin_number, id)
      .then((r) => {
        setIsError(false);
        setUserProgress(r.data.progress);
        setProgressInfo(r.data.info?.message);
        setJoinedChallengeModalOpen(true);
        setJoinedChallenge(true);
        getData();
      })
      .catch((error) => {
        showToast(error.response.data.error, "error");
        setIsError(true);
        console.error("Error during challenge joining", error);
      });
  };

  const tabelHeightCalc = () => {
    if (preview) return 0;
    if (isFollowingChecked === false && selectedStatus === "all") return 134;
    return 166;
  };

  const rowPinningState =
    userName && data.some((row) => row.name === userName) && isRowPinned
      ? { top: [userName] }
      : { top: [] };

  const columns = useMemo(() => {
    const round_size = isSmallScreen ? 35 : 70;
    const position_size = isSmallScreen ? 35 : 90;
    const baseColumns = [
      {
        accessorKey: "position",
        header: isSmallScreen ? "POS" : "POSITION",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        grow: false,
        size: position_size,
        Cell: ({ row }) => (
          <div className="row">
            <span className="position-cell" style={{ fontSize: "16px" }}>
              <div className="col is-1-of-2">
                {row.original.position_display}
              </div>
              {currentUser && !isSmallScreen && (
                <div className="col is-2-of-2">
                  {row.original.followed === true ? (
                    <Star className="icon-star" />
                  ) : (
                    <StarOutline className="icon-star-outline" />
                  )}
                </div>
              )}
            </span>
          </div>
        ),
        muiTableHeadCellProps: { className: "header-position" },
        muiTableBodyCellProps: { className: "body-position" },
      },
      {
        accessorKey: "name",
        header: computed_name,
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: 120,
        Cell: ({ row }) => (
          <span className="name-cell">
            <span className="name-display">
              {row.original.short_name && isSmallScreen
                ? row.original.short_name
                : row.original.name}
            </span>
            {currentUser && (
              <span className="handicap-display">
                {row.original.hi_display}
              </span>
            )}
          </span>
        ),
        muiTableHeadCellProps: { className: "header-name" },
        muiTableBodyCellProps: { className: "body-name" },
      },
      {
        accessorKey: "total",
        header: isSmallScreen ? "Total" : "TOTAL",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span
            className={
              row.original.total?.includes("-")
                ? "total-negative"
                : "total-positive"
            }
            style={{ fontWeight: "100", fontFamily: "National Narrow Bold" }}
          >
            {row.original.total}
          </span>
        ),
        muiTableHeadCellProps: {
          className: "header-total",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
              fontWeight: "700",
              color: "rgba(16, 24, 40, 1)",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-total" },
      },
      {
        accessorKey: "r1",
        header: isSmallScreen ? "R1" : "RD1",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r1}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
              fontWeight: "500",
              color: "rgba(16, 24, 40, 1)",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
      {
        accessorKey: "r2",
        header: isSmallScreen ? "R2" : "RD2",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r2}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
              fontWeight: "500",
              color: "rgba(16, 24, 40, 1)",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
      {
        accessorKey: "r3",
        header: isSmallScreen ? "R3" : "RD3",
        enableSorting: false,
        enableFiltering: false,
        enableColumnActions: false,
        size: round_size,
        grow: false,
        Cell: ({ row }) => (
          <span className="round-cell">{row.original.r3}</span>
        ),
        muiTableHeadCellProps: {
          className: "header-round",
          sx: {
            "& .Mui-TableHeadCell-Content": {
              justifyContent: "center",
              fontWeight: "500",
              color: "rgba(16, 24, 40, 1)",
            },
          },
        },
        muiTableBodyCellProps: { className: "body-round" },
      },
    ];
    return baseColumns;
  }, [isSmallScreen, currentUser, computed_name]);

  // Create the table instance.
  const table = useMaterialReactTable({
    columns,
    data,
    layoutMode: "grid",
    defaultColumn: { minSize: 35 },
    enablePagination: false,
    enableBottomToolbar: false,
    enableStickyHeader: true,
    getRowId: (row) => row.name,
    initialState: {
      density: "compact",
      expanded: true,
    },
    state: { rowPinning: rowPinningState },
    enableColumnFilterModes: false,
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enableHiding: false,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    muiTableHeadRowProps: {
      sx: { boxShadow: "none" },
    },
    muiTablePaperProps: {
      sx: { boxShadow: "none" },
    },
    muiTableBodyRowProps: ({ row }) => {
      const isCurrentUserRow = row.id === userName;
      return {
        sx: {
          height: isSmallScreen ? "43px" : "77px",
          bottom: 0,
          top: isCurrentUserRow ? (isRowPinned ? "34px" : 0) : 0,
          zIndex: isCurrentUserRow ? 2 : 0,
          position: isCurrentUserRow
            ? isRowPinned
              ? "sticky"
              : "relative"
            : "relative",
          backgroundColor: isCurrentUserRow ? "rgb(237, 243, 247)" : undefined,
          cursor: isCurrentUserRow && isRowPinned ? "pointer" : "default",
        },
        onClick:
          isCurrentUserRow && isRowPinned ? handlePinnedRowClick : undefined,
        ref: !isRowPinned && isCurrentUserRow ? userRowRef : undefined,
      };
    },
    muiTableContainerProps: {
      ref: tableContainerRef,
      sx: {
        height: `calc(100vh - ${tabelHeightCalc()}px)`,
        position: "relative",
        padding: "0 10px",
        "@media (max-width: 600px)": {
          maxWidth: "100%",
          overflowX: "auto",
          fontSize: "6px",
        },
        "@media (min-width: 601px)": {
          maxWidth: "100%",
          fontSize: "10px",
        },
      },
    },
  });

  return (
    <div className="challenge-page-container">
      <div className="challenges-page-header">Challenges</div>
      {!preview && (
        <div className="challenge-content">
          <div className="challenge-header-container">
            <ChallengeInfoBox
              challengeInfo={challengeInfo}
              joinedChallenge={joinedChallenge}
              onConfirmChallengeModal={onConfirmChallengeModal}
              isError={isError}
            />
            {joinedChallenge ? (
              <ChallengeActivityBox
                joinedChallenge={joinedChallenge}
                userProgress={userProgress}
                daysLeft={challengeInfo?.days_left}
                totalScore={totalScore}
                topScores={topScores}
                userName={userName}
                openViewScoresModal={openViewScoresModal}
              />
            ) : (
              <ChallengeLearnMoreBox setInfoModalOpen={setInfoModalOpen} />
            )}
          </div>

          <div className="leaderboard-container">
            <div className="white-rectangle">
              <div className="leaderboard-header">
                <div className="challenge-leaderboard-title">Leaderboard</div>
                {currentUser && (
                  <ChallengeLeaderboardFilter
                    isFollowingChecked={isFollowingChecked}
                    handleFollowingChange={handleFollowingChange}
                    selectedStatus={selectedStatus}
                    handleStatusChange={(value) => handleStatusChange(value)}
                  />
                )}
              </div>

              <MaterialReactTable table={table} />

              {!preview && (
                <div className="challenge-bottom-buttons">
                  <button
                    className="btn outline blue"
                    style={{
                      borderRadius: "20px",
                    }}
                    onClick={() => {
                      Navigate.toPath(
                        `/leaderboard-details/${challengeInfo?.id}`
                      );
                    }}
                  >
                    VIEW FULL LEADERBOARD
                  </button>
                  {joinedChallenge && (
                    <button
                      onClick={() =>
                        setLeaveChallengeConfirmationModalOpen(true)
                      }
                      className="leave-button"
                    >
                      <div className="material-icons-outlined leave-icon">
                        logout
                      </div>
                      Leave Challenge
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          <JoinChallengeInfoModal
            isOpen={infoModalOpen}
            closeModal={closeModal}
          />
          <ViewScoresModal
            isOpen={ViewScoresModalOpen}
            closeModal={closeViewScoresModal}
            challengeName={challengeInfo?.name.toUpperCase()}
            scores={allScores}
            topScoreIds={topScores.map((score) => score.score_id)}
          />
          <JoinedChallengeModal
            title={`You joined the ${challengeInfo?.name}`}
            content={progressInfo}
            progress={userProgress}
            isOpen={joinedChallengeModalOpen}
            challengeId={challengeInfo?.id}
            onConfirmModal={() => {
              setJoinedChallengeModalOpen(false);
            }}
            onCloseModal={() => {
              setJoinedChallengeModalOpen(false);
            }}
          />
          <LeaveChallengeConfirmationModal
            isOpen={leaveChallengeConfirmationModalOpen}
            challengeName={challengeInfo?.name}
            onConfirm={handleLeaveChallenge}
            closeModal={closeLeaveChallengeConfirmationModal}
          />
        </div>
      )}
    </div>
  );
}
